import { connect } from 'react-redux';
import { isNil, get } from 'lodash';
import Past, {
  PastProps,
} from '@/components/DeprecatedPortfolio/components/Past';
import { portfolioSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import {
  getMarketAverageROASelector,
  getMarketAverageROESelector,
  getMarketAverageCountryNameSelector,
} from '@industyAverages/redux/selectors';

type StateProps = Omit<PastProps, 'sectionNumber'>;
const mapStateToProps = (state): StateProps => {
  const portfolio = portfolioSelector(state);

  const industyAveragesProps = {
    industryId: 0,
    marketISO2: get(portfolio, ['marketISO2'], ''),
  };

  const marketAverageROA = getMarketAverageROASelector(
    state,
    industyAveragesProps
  );

  const marketAverageROE = getMarketAverageROESelector(
    state,
    industyAveragesProps
  );

  const marketName = getMarketAverageCountryNameSelector(
    state,
    industyAveragesProps
  );

  return {
    portfolioId: get(portfolio || {}, ['id'], ''),
    secretCode: get(portfolio || {}, ['secretCode'], undefined),
    marketName,
    ROA: get(portfolio || {}, ['ROA'], undefined),
    marketROA: !isNil(marketAverageROA) ? marketAverageROA.value : undefined,
    ROE: get(portfolio || {}, ['ROE'], undefined),
    marketROE: !isNil(marketAverageROE) ? marketAverageROE.value : undefined,
    ROCE: get(portfolio || {}, ['ROCE'], undefined),
    portfolioName: get(portfolio || {}, ['name'], ''),
    netIncomeGrowth5y: get(portfolio || {}, ['netIncomeGrowth5y'], undefined),
    revenueGrowth5y: get(portfolio || {}, ['revenueGrowth5y'], undefined),
  };
};
export default connect<StateProps, undefined, Partial<PastProps>>(
  mapStateToProps
)(Past);
